import { render, staticRenderFns } from "./StageRender.vue?vue&type=template&id=e5d630ac&scoped=true&"
import script from "./StageRender.vue?vue&type=script&lang=ts&"
export * from "./StageRender.vue?vue&type=script&lang=ts&"
import style0 from "./StageRender.vue?vue&type=style&index=0&id=e5d630ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d630ac",
  null
  
)

export default component.exports